<template>
  <div class="reclaimModal">
    <NsModal
      :fullscreen="false"
      :info="true"
      :persistent="true"
      small="true"
      v-model="show"
    >
      <div class="reclaimModalContent">
        <div class="reclaimModalHeader">
          <div class="reclaimModalHeaderText">{{tdc.tdc_reclaimHeader}}</div>
          <div class="reclaimModalHeaderClose" @click="closeModal(false)">
            <NsIcon icon-name="icon-close" />
          </div>
        </div>
        <p class="reclaimModalText">{{tdc.tdc_reclaimText}}</p>
        <div class="reclaim-quantity">
          <div class="quantity-label">{{tdc.tdc_quantityLabel}}</div>
          <div class="quantity-select">
            <ns-select
              v-model="reclaimAmount"
              :items="reclaimAmounts"
              name="reclaimSelect"
            />
          </div>
          <div class="quantity-of">
            / {{shared ? shared.canReclaim : 0}}
          </div>
        </div>
        <div class="reclaimModalButtons">
          <button
            class="reclaimModalAcceptButton reclaimModalReturnSelectedButton"
            :class="{ disableReclaimModalButton: reclaimingAllocations === true }"
            @click="closeModal(true)"
          >
            <CustomSpinner v-if="reclaimingAllocations" />{{tdc.tdc_reclaim}}
          </button>
          <button
            class="reclaimModalCancelButton primary-outline"
            @click="closeModal()"
          >
            {{tdc.tdc_cancel}}
          </button>
        </div>
        <div v-if="returnError" class="returnError">
          {{tdc.tdc_failedToSendQualifications}}
        </div>
      </div>
    </NsModal>
  </div>
</template>

<script>

import { events } from '@nuskin/ns-util'
import { NsModal, NsSelect } from '@nuskin/design-components'
import { NsIcon } from '@nuskin/ns-icon'
import CustomSpinner from '../../components/CustomSpinner.vue'
import config from '../../js/qualificationsConfigService'

export default {
  name: 'ReclaimModal',

  components: {
    NsModal,
    NsIcon,
    NsSelect,
    CustomSpinner
  },

  props: {
    sharerId: {
      type: String,
      required: true
    },
    shared: {
      type: Object,
      required: true
    },
    sharedSku: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      reclaimingAllocations: false,
      reclaimAmount: 1,
      reclaimError: false,
      tdc: config.getTdc()
    }
  },

  watch: {
  },

  computed: {
    reclaimAmounts() {
      let arr = []

      if (this.shared) {
        arr = [...Array(this.shared.canReclaim + 1).keys()].splice(1)
      }

      return arr
    }
  },

  methods: {
    async closeModal(doReclaim) {
      if (!this.reclaimingAllocations) {
        let response

        this.reclaimingAllocations = true
        if (doReclaim) {
          try {
            response = await aem.QualificationService.reclaimQualifications([{
              customerId: this.shared.customerId,
              sku: this.sharedSku,
              quantity: this.reclaimAmount
            }])
            events.publish('qualificationReclaimed')
          } catch (err) {
            events.publish('qualificationReclaimError')
          }
        }
        this.$emit('close-reclaim-modal', doReclaim ? response.qualifications[this.sharedSku] : null)
        this.reclaimingAllocations = false
      }
    }
  }
}
</script>

<style lang="scss">
  @use "sass:map";
  @use "~@nuskin/ns-core-styles/src/scss/colors";

  $noticeColor: map.get(colors.$baseColors, "notice-color");
  $blackhole: map.get(colors.$baseColors, "blackhole");

  .reclaimModalContent {
    display: flex;
    flex-direction: column;
    color: $blackhole;
    font-family: 'proxima-nova';
    .reclaimModalHeader {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .reclaimModalHeaderText {
        font-weight: 600;
        font-size: 18px;
        text-align: left;
      }
      .reclaimModalHeaderClose {
        cursor: pointer;
      }
    }
    .reclaimModalText {
      align-self: flex-start;
      margin-bottom: 15px;
      font-weight: 300;
      color: $blackhole;
      text-align: left;
    }
    .reclaimModalButtons {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      /*margin-bottom: 15px;*/
      button {
        border-radius: 3px;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        height: 45px;
        width: auto;
        display: flex;
        justify-content: center;
        margin-bottom: 0;
      }
      button.reclaimModalCancelButton {
        margin-top: 10px;
        font-weight: 600;
      }
      button.reclaimModalAcceptButton {
        background-color: $blackhole;
        color: white;
        font-weight: 400;
      }
      button.disableReclaimModalButton {
        background-color: #515157;
      }
      button.reclaimModalAcceptButton:hover {
        background-color: #515157;
        border-color: #515157;
      }
    }
    .returnError {
      color: #B2140A;
      font-size: 16px;
    }
  }

  .reclaim-quantity {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .quantity-label{
      padding-right: 8px;
    }

    .quantity-select {
      width: 60px;

      .v-select__selection--comma,
      .v-select__slot .v-input__append-inner {
        z-index: 100 !important;
      }

      .v-select__slot .v-select__selections .v-select__selection--comma {
        left: 10px;
      }

      .v-select-list {
        padding: 0 !important;
      }

      .v-text-field__details {
        display: none;
      }
    }

    .quantity-of {
      padding-left: 5px;
      justify-content: flex-start;
    }
  }

  // Overriding NsModal's default behavior.
  .v-dialog__content {
    .v-dialog.modal-info {
      color: red;
      // Scoped normally takes precedence, so important is needed.
      // border-top-color: $noticeColor !important;
      box-shadow: none;
      border: none !important; // 1px solid #63666A;
      border-radius: 5px !important;
      // We can't access the close button's and change its behavior.
      // So we don't display it.

      .modal__header {
        display: none;
      }
      .v-card__text {
        margin-top: 0;
        .container.grid-list-md {
          padding-bottom: 0;
        }
      }
    }
  }

  @media (max-width: 375px) {
    .reclaimModalButtons {
      flex-direction: column-reverse;
      button {
        width: auto !important;
      }

      button.reclaimModalCancelButton {
        margin-top: 10px;
        padding-left: 0 !important;
        border: 1px solid #272525;
      }
    }
  }
</style>
